export default __webpack_public_path__ + "static/media/img2.4114edcd.png";